import React, { useEffect, useState } from "react"
import { CategoriesApi } from "../../../services/CallApi"
import ApiURL from "../../../services/ApiURL"
import { ErrorUI } from "../../UI/Modals/Modals"
import { useSelector } from "react-redux"
import CategoryProfileBox from "../CategoryProfileBox/CategoryProfileBox"
import VideoCarousel from "../VideoCarousel/VideoCarousel"

export default function CategoryCarousel({ cats, shouldHitApi }) {
  const { defaultGym } = useSelector((state) => state.profile.profileData)
  const [categories, setCategories] = useState([])
  useEffect(() => {
    if (defaultGym && shouldHitApi) {
      getCategories()
    }
  }, [defaultGym])
  const getCategories = () => {
    const data = {
      limit: 20,
      offset: 0,
      gym_id: defaultGym.gym_id,
    }
    CategoriesApi(ApiURL._listCategories, data).then((res) => {
      if (res.status) {
        setCategories(res.list)
      } else {
        ErrorUI(res.list, () => getCategories())
      }
    })
  }
  let categoriesUI = []
  if (cats && cats.length) {
    categoriesUI = cats.map((category) => {
      return (
        <CategoryProfileBox
          key={category.category_id}
          id={category.category_id}
          name={category.category_name}
          icon={category.category_image_thumb}
          full={!category.is_icon_selected}
        />
      )
    })
  } else {
    categoriesUI = categories.map((category) => {
      return (
        <CategoryProfileBox
          key={category.category_id}
          id={category.category_id}
          name={category.category_name}
          icon={category.category_image_thumb}
          full={!category.is_icon_selected}
        />
      )
    })
  }
  return categoriesUI.length ? (
    <VideoCarousel heading="CATEGORIES">{categoriesUI}</VideoCarousel>
  ) : null
}
